/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import NftGeneratorControllerDtoAddNftKeyIndexRequest from '../model/NftGeneratorControllerDtoAddNftKeyIndexRequest';
import NftGeneratorControllerDtoAddNftUidIndexRequest from '../model/NftGeneratorControllerDtoAddNftUidIndexRequest';
import NftGeneratorControllerDtoNftBurnRequest from '../model/NftGeneratorControllerDtoNftBurnRequest';
import NftGeneratorControllerDtoNftGenerateRequest from '../model/NftGeneratorControllerDtoNftGenerateRequest';
import NftGeneratorControllerDtoNftGenerateResponse from '../model/NftGeneratorControllerDtoNftGenerateResponse';
import NftGeneratorControllerDtoNftImageGenerateRequest from '../model/NftGeneratorControllerDtoNftImageGenerateRequest';
import NftGeneratorControllerDtoNftImageGenerateResponse from '../model/NftGeneratorControllerDtoNftImageGenerateResponse';
import NftGeneratorControllerDtoNftImageRecoveryRequest from '../model/NftGeneratorControllerDtoNftImageRecoveryRequest';
import NftGeneratorControllerDtoNftImageRecoveryResponse from '../model/NftGeneratorControllerDtoNftImageRecoveryResponse';
import NftGeneratorControllerDtoRemoveNftKeyIndexRequest from '../model/NftGeneratorControllerDtoRemoveNftKeyIndexRequest';
import NftGeneratorControllerDtoRemoveNftUidIndexRequest from '../model/NftGeneratorControllerDtoRemoveNftUidIndexRequest';

/**
* NftGenerator service.
* @module api/NftGeneratorApi
* @version 1.0
*/
export default class NftGeneratorApi {

    /**
    * Constructs a new NftGeneratorApi. 
    * @alias module:api/NftGeneratorApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiNftGeneratorAddNftKeyIndexPost operation.
     * @callback module:api/NftGeneratorApi~apiNftGeneratorAddNftKeyIndexPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftGeneratorControllerDtoAddNftKeyIndexRequest} [nftGeneratorControllerDtoAddNftKeyIndexRequest] 
     * @param {module:api/NftGeneratorApi~apiNftGeneratorAddNftKeyIndexPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiNftGeneratorAddNftKeyIndexPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftGeneratorControllerDtoAddNftKeyIndexRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/NftGenerator/AddNftKeyIndex', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiNftGeneratorAddNftUidIndexPost operation.
     * @callback module:api/NftGeneratorApi~apiNftGeneratorAddNftUidIndexPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftGeneratorControllerDtoAddNftUidIndexRequest} [nftGeneratorControllerDtoAddNftUidIndexRequest] 
     * @param {module:api/NftGeneratorApi~apiNftGeneratorAddNftUidIndexPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiNftGeneratorAddNftUidIndexPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftGeneratorControllerDtoAddNftUidIndexRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/NftGenerator/AddNftUidIndex', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiNftGeneratorNftBurnPost operation.
     * @callback module:api/NftGeneratorApi~apiNftGeneratorNftBurnPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftGeneratorControllerDtoNftBurnRequest} [nftGeneratorControllerDtoNftBurnRequest] 
     * @param {module:api/NftGeneratorApi~apiNftGeneratorNftBurnPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiNftGeneratorNftBurnPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftGeneratorControllerDtoNftBurnRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/NftGenerator/NftBurn', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiNftGeneratorNftGeneratePost operation.
     * @callback module:api/NftGeneratorApi~apiNftGeneratorNftGeneratePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NftGeneratorControllerDtoNftGenerateResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftGeneratorControllerDtoNftGenerateRequest} [nftGeneratorControllerDtoNftGenerateRequest] 
     * @param {module:api/NftGeneratorApi~apiNftGeneratorNftGeneratePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NftGeneratorControllerDtoNftGenerateResponse}
     */
    apiNftGeneratorNftGeneratePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftGeneratorControllerDtoNftGenerateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = NftGeneratorControllerDtoNftGenerateResponse;
      return this.apiClient.callApi(
        '/api/NftGenerator/NftGenerate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiNftGeneratorNftImageGeneratePost operation.
     * @callback module:api/NftGeneratorApi~apiNftGeneratorNftImageGeneratePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NftGeneratorControllerDtoNftImageGenerateResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftGeneratorControllerDtoNftImageGenerateRequest} [nftGeneratorControllerDtoNftImageGenerateRequest] 
     * @param {module:api/NftGeneratorApi~apiNftGeneratorNftImageGeneratePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NftGeneratorControllerDtoNftImageGenerateResponse}
     */
    apiNftGeneratorNftImageGeneratePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftGeneratorControllerDtoNftImageGenerateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = NftGeneratorControllerDtoNftImageGenerateResponse;
      return this.apiClient.callApi(
        '/api/NftGenerator/NftImageGenerate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiNftGeneratorNftImageRecoveryPost operation.
     * @callback module:api/NftGeneratorApi~apiNftGeneratorNftImageRecoveryPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/NftGeneratorControllerDtoNftImageRecoveryResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftGeneratorControllerDtoNftImageRecoveryRequest} [nftGeneratorControllerDtoNftImageRecoveryRequest] 
     * @param {module:api/NftGeneratorApi~apiNftGeneratorNftImageRecoveryPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/NftGeneratorControllerDtoNftImageRecoveryResponse}
     */
    apiNftGeneratorNftImageRecoveryPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftGeneratorControllerDtoNftImageRecoveryRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = NftGeneratorControllerDtoNftImageRecoveryResponse;
      return this.apiClient.callApi(
        '/api/NftGenerator/NftImageRecovery', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiNftGeneratorRemoveNftKeyIndexPost operation.
     * @callback module:api/NftGeneratorApi~apiNftGeneratorRemoveNftKeyIndexPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftGeneratorControllerDtoRemoveNftKeyIndexRequest} [nftGeneratorControllerDtoRemoveNftKeyIndexRequest] 
     * @param {module:api/NftGeneratorApi~apiNftGeneratorRemoveNftKeyIndexPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiNftGeneratorRemoveNftKeyIndexPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftGeneratorControllerDtoRemoveNftKeyIndexRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/NftGenerator/RemoveNftKeyIndex', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiNftGeneratorRemoveNftUidIndexPost operation.
     * @callback module:api/NftGeneratorApi~apiNftGeneratorRemoveNftUidIndexPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/NftGeneratorControllerDtoRemoveNftUidIndexRequest} [nftGeneratorControllerDtoRemoveNftUidIndexRequest] 
     * @param {module:api/NftGeneratorApi~apiNftGeneratorRemoveNftUidIndexPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiNftGeneratorRemoveNftUidIndexPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['nftGeneratorControllerDtoRemoveNftUidIndexRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/NftGenerator/RemoveNftUidIndex', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
